import React, { useContext } from "react";
import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Button,
  ButtonGroup,
  Container,
  Toolbar,
  Typography,
  Grid,
} from "@material-ui/core";
import {
  LinkedIn,
  Twitter,
  Facebook,
  Instagram,
  YouTube,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(0.5, 0),
    margin: theme.spacing(2, 0, 0, 0),
    backgroundColor: "#f6f6f6",
    color: "#504538",
  },
}));
const mediaButtons = [
  {
    icon: <LinkedIn style={{ color: "#504538" }} />,
    link: "https://www.linkedin.com/company/a-i-mergence/",
  },
  {
    icon: <Twitter style={{ color: "#504538" }} />,
    link: "https://twitter.com/ai_mergence",
  },
  {
    icon: <Facebook style={{ color: "#504538" }} />,
    link: "https://www.facebook.com/A.I.Mergence/",
  },
  {
    icon: <Instagram style={{ color: "#504538" }} />,
    link: "https://www.instagram.com/a.i.mergence/",
  },
  {
    icon: <YouTube style={{ color: "#504538" }} />,
    link: "https://www.youtube.com/channel/UCQWhx67FYu0CRnxdJk2_COw",
  },
];

const Footer = (props) => {
  const { language } = useContext(LanguageContext);
  const classes = useStyles();

  return (
    <AppBar position="static" classes={{ root: classes.footer }}>
      <Toolbar component="nav">
        <Container maxWidth="md">
          <Grid container style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <ButtonGroup>
                {mediaButtons.map((value, index) => (
                  <Button
                    variant="text"
                    key={`footerButton${index}`}
                    color="inherit"
                    onClick={() => window.open(value.link)}
                  >
                    {value.icon}
                  </Button>
                ))}
              </ButtonGroup>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                color="inherit"
                className={classes.footer}
              >
                © {new Date().getFullYear()}&nbsp;
                {localize("app.name", language)}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
